webpackJsonp([2,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _keys = __webpack_require__(16);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _vue = __webpack_require__(59);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueI18n = __webpack_require__(44);
	
	var _vueI18n2 = _interopRequireDefault(_vueI18n);
	
	var _vueRouter = __webpack_require__(58);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueHead = __webpack_require__(43);
	
	var _vueHead2 = _interopRequireDefault(_vueHead);
	
	var _Top = __webpack_require__(48);
	
	var _Top2 = _interopRequireDefault(_Top);
	
	var _Overview = __webpack_require__(47);
	
	var _Overview2 = _interopRequireDefault(_Overview);
	
	var _Members = __webpack_require__(46);
	
	var _Members2 = _interopRequireDefault(_Members);
	
	var _Contact = __webpack_require__(45);
	
	var _Contact2 = _interopRequireDefault(_Contact);
	
	var _vueMaterials = __webpack_require__(57);
	
	var _vueMaterials2 = _interopRequireDefault(_vueMaterials);
	
	var _Navbar = __webpack_require__(50);
	
	var _Navbar2 = _interopRequireDefault(_Navbar);
	
	var _Footbar = __webpack_require__(49);
	
	var _Footbar2 = _interopRequireDefault(_Footbar);
	
	var _Translation = __webpack_require__(9);
	
	var _Translation2 = _interopRequireDefault(_Translation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueI18n2.default);
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_vueMaterials2.default);
	_vue2.default.use(_vueHead2.default);
	
	_vue2.default.config.lang = 'ja';
	
	
	var locales = _Translation2.default.language;
	(0, _keys2.default)(locales).forEach(function (lang) {
	  _vue2.default.locale(lang, locales[lang]);
	});
	
	var router = new _vueRouter2.default({
	  mode: 'history',
	  routes: [{ path: '/', component: _Top2.default }, { path: '/overview', component: _Overview2.default }, { path: '/members', component: _Members2.default }, { path: '/contact', component: _Contact2.default }]
	});
	
	_vue2.default.component('app-header', _Navbar2.default);
	_vue2.default.component('app-footer', _Footbar2.default);
	
	new _vue2.default({
	  router: router
	}).$mount('#app');

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  language: {
	    en: {
	      menu: {
	        top: 'Top',
	        overview: 'Overview',
	        members: 'Members',
	        contact: 'Contact'
	      },
	      footer: {
	        name: 'Hoge.class mission',
	        mission: '私たちはマインクラフトが大好きです。そして、このゲームをもっと多くの方々に楽しんでもらいたいと思っています。<br>' + 'マインクラフトはただ遊ぶだけではなく、マイクラファンが開発する拡張機能を使えばプログラミングによって、自由に遊びを創造することができます。' + '多人数で遊びたいと思い、まともマルチサーバを建てると、ネットワークの知識を得ることができます。<br>' + '今日、子供のIT教育にもマインクラフトが使用されたり、機械学習の勉強にも使用されています。<br>' + '私たちのミッションは、この素晴らしいゲームを遊ぶ人たちを増やし、正しく優良な情報を提供する場を作ることで、社会貢献を行うことです。'
	      },
	      top: {
	        title: 'Minecraft <small>doujin club</small>',
	        circle_name: 'Hoge.class',
	        whats_doujin: 'What\'s minecraft "doujin"?'
	      }
	    },
	    ja: {
	      menu: {
	        top: 'トップ',
	        overview: '概要',
	        members: 'メンバー',
	        contact: 'お問合せ'
	      },
	      footer: {
	        name: 'ほげ.class ミッション',
	        mission: '私たちはマインクラフトが大好きです。そして、このゲームをもっと多くの方々に楽しんでもらいたいと思っています。<br>' + 'マインクラフトはただ遊ぶだけではなく、マイクラファンが開発する拡張機能を使えばプログラミングによって、自由に遊びを創造することができます。' + '多人数で遊びたいと思い、まともマルチサーバを建てると、ネットワークの知識を得ることができます。<br>' + '今日、子供のIT教育にもマインクラフトが使用されたり、機械学習の勉強にも使用されています。<br>' + '私たちのミッションは、この素晴らしいゲームを遊ぶ人たちを増やし、正しく優良な情報を提供する場を作ることで、社会貢献を行うことです。'
	      },
	      top: {
	        title: 'Minecraft <small>同人サークル</small>',
	        circle_name: 'ほげ.class',
	        whats_doujin: 'マイクラ同人とは？'
	      }
	    }
	  }
	};

/***/ },
/* 10 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'contact',
	  head: {
	    title: {
	      inner: 'お問合せ'
	    }
	  }
	};

/***/ },
/* 11 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'members',
	  head: {
	    title: {
	      inner: 'サークルメンバー'
	    }
	  }
	};

/***/ },
/* 12 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'overview',
	  head: {
	    title: {
	      inner: 'サークル概要'
	    }
	  }
	};

/***/ },
/* 13 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'top',
	  head: {
	    title: {
	      inner: 'トップ'
	    }
	  }
	};

/***/ },
/* 14 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'footbar'
	};

/***/ },
/* 15 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'navbar'
	};

/***/ },
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(10)
	
	/* template */
	var __vue_template__ = __webpack_require__(51)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(11)
	
	/* template */
	var __vue_template__ = __webpack_require__(52)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(12)
	
	/* template */
	var __vue_template__ = __webpack_require__(54)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(13)
	
	/* template */
	var __vue_template__ = __webpack_require__(55)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(14)
	
	/* template */
	var __vue_template__ = __webpack_require__(53)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(15)
	
	/* template */
	var __vue_template__ = __webpack_require__(56)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 51 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;
	  return _vm._h('main', [_vm._h('div', [_vm._h('v-container', [_vm._h('v-card', {}, [_vm._m(0), " ", _vm._h('iframe', {
	    attrs: {
	      "src": "https://docs.google.com/forms/d/e/1FAIpQLSdku7asj-prSaEg0YWi3DPks6ACtATcP1Gmjoow2srjIvoI6w/viewform?embedded=true",
	      "width": "100%",
	      "height": "1150",
	      "frameborder": "0",
	      "marginheight": "5",
	      "marginwidth": "10px"
	    }
	  }, ["読み込んでいます..."])])])])])
	},staticRenderFns: [function (){var _vm=this;
	  return _vm._h('div', {
	    staticClass: "card-content"
	  }, [_vm._h('img', {
	    attrs: {
	      "src": "/static/svg/communication/writing.svg",
	      "style": "height: 40px;"
	    }
	  }), " ", _vm._h('span', {
	    staticClass: "card-title",
	    attrs: {
	      "style": "vertical-align:top;"
	    }
	  }, ["\n            お問合せ\n          "])])
	}]}

/***/ },
/* 52 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;
	  return _vm._h('main', [_vm._h('div', [_vm._h('v-container', [_vm._h('v-card', {}, [_vm._m(0)])])])])
	},staticRenderFns: [function (){var _vm=this;
	  return _vm._h('div', {
	    staticClass: "card-content"
	  }, [_vm._h('img', {
	    attrs: {
	      "src": "/static/svg/communication/user.svg",
	      "style": "height: 40px;"
	    }
	  }), " ", _vm._h('span', {
	    staticClass: "card-title",
	    attrs: {
	      "style": "vertical-align:top;"
	    }
	  }, ["\n            サークルメンバー\n          "]), " ", _vm._h('table', {
	    staticClass: "bordered"
	  }, [_vm._h('thead', [_vm._h('tr', [_vm._h('th', {
	    attrs: {
	      "data-field": "id"
	    }
	  }, ["名前"]), " ", _vm._h('th', {
	    attrs: {
	      "data-field": "name"
	    }
	  }, ["役職"])])]), " ", _vm._h('tbody', [_vm._h('tr', [_vm._h('td', ["宮乃ぺこ"]), " ", _vm._h('td', ["代表"])]), " ", _vm._h('tr', [_vm._h('td', ["明地えしら"]), " ", _vm._h('td')]), " ", _vm._h('tr', [_vm._h('td', ["ecolight"]), " ", _vm._h('td')]), " ", _vm._h('tr', [_vm._h('td', ["うりMk-2"]), " ", _vm._h('td')]), " ", _vm._h('tr', [_vm._h('td', ["ryuto"]), " ", _vm._h('td')]), " ", _vm._h('tr', [_vm._h('td', ["すず"]), " ", _vm._h('td')])])])])
	}]}

/***/ },
/* 53 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;
	  return _vm._h('v-footer', {
	    staticClass: "grey lighten-3"
	  }, [_vm._h('div', {
	    slot: "content",
	    staticClass: "container"
	  }, [_vm._h('div', {
	    staticClass: "row"
	  }, [_vm._h('div', {
	    staticClass: "col l6 s12"
	  }, [_vm._m(0), " ", _vm._h('ul', [_vm._h('li', {
	    staticClass: "sub-menu-item black-text"
	  }, [_vm._h('a', {
	    attrs: {
	      "href": "/"
	    }
	  }, [_vm._s(_vm.$t('menu.top'))])]), " ", _vm._h('li', {
	    staticClass: "sub-menu-item black-text"
	  }, [_vm._h('a', {
	    attrs: {
	      "href": "/overview"
	    }
	  }, [_vm._s(_vm.$t('menu.overview'))])]), " ", _vm._h('li', {
	    staticClass: "sub-menu-item black-text"
	  }, [_vm._h('a', {
	    attrs: {
	      "href": "/members"
	    }
	  }, [_vm._s(_vm.$t('menu.members'))])]), " ", _vm._h('li', {
	    staticClass: "sub-menu-item black-text"
	  }, [_vm._h('a', {
	    attrs: {
	      "href": "/contact"
	    }
	  }, [_vm._s(_vm.$t('menu.contact'))])])])]), " ", _vm._m(1)]), " ", _vm._m(2)]), " ", _vm._h('div', {
	    slot: "copyright",
	    staticClass: "container black-text"
	  }, ["\n    © Copyright 2014-2016 ほげ.class (Hoge.class)\n  "])])
	},staticRenderFns: [function (){var _vm=this;
	  return _vm._h('h5', {
	    staticClass: "black-text"
	  }, ["ほげ.class サイトマップ"])
	},function (){var _vm=this;
	  return _vm._h('div', {
	    staticClass: "col l4 offset-l2 s12"
	  }, [_vm._h('h5', {
	    staticClass: "black-text"
	  }, ["Links"]), " ", _vm._h('ul', [_vm._h('li', [_vm._h('a', {
	    staticClass: "black-text",
	    attrs: {
	      "href": "https://minecraft.net/ja/"
	    }
	  }, ["Minecraft"])]), " ", _vm._h('li', [_vm._h('a', {
	    staticClass: "black-text",
	    attrs: {
	      "href": "http://forum.minecraftuser.jp/"
	    }
	  }, ["非公式日本ユーザフォーラム"])]), " ", _vm._h('li', [_vm._h('a', {
	    staticClass: "black-text",
	    attrs: {
	      "href": "https://minecraft.jp/"
	    }
	  }, ["Japan Minecraft Servers"])])])])
	},function (){var _vm=this;
	  return _vm._h('p', ["当サイトで使用しているアイコンの一部は、Flaticon のものを使用しています。Designed by Freepik and distributed by Flaticon"])
	}]}

/***/ },
/* 54 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;
	  return _vm._h('main', [_vm._h('div', [_vm._h('v-container', [_vm._h('v-card', {}, [_vm._m(0)])])])])
	},staticRenderFns: [function (){var _vm=this;
	  return _vm._h('div', {
	    staticClass: "card-content"
	  }, [_vm._h('img', {
	    attrs: {
	      "src": "/static/svg/communication/chat-1.svg",
	      "style": "height: 40px;"
	    }
	  }), " ", _vm._h('span', {
	    staticClass: "card-title",
	    attrs: {
	      "style": "vertical-align:top;"
	    }
	  }, ["\n            サークル概要\n          "]), " ", _vm._h('p', ["\n            ほげ.class は2014年に、マインクラフトサーバMODである「CraftBukkit」の本を書くための、\n            個人（同人）サークルとして誕生しました。\n            その後、コミックマーケットをはじめ、超会議、マインクラフトオンリーといったイベントに参加する過程で、\n            多くのマインクラフトファンや、教育、メディア関係の方々にお会いし、個人活動に留めるにはもったいないと感じました。\n          "]), " ", _vm._h('hr'), " ", _vm._h('img', {
	    attrs: {
	      "src": "/static/svg/communication/newspaper.svg",
	      "style": "height: 40px;"
	    }
	  }), " ", _vm._h('span', {
	    staticClass: "card-title",
	    attrs: {
	      "style": "vertical-align:top;"
	    }
	  }, ["\n            なぜ同人誌？\n          "]), " ", _vm._h('p', ["\n            同人誌執筆のきっかけは、ニコニコ生放送のユーザ配信で行われていたマインクラフトイベントでした。", _vm._h('br'), "\n            もちろん、それらはサーバMODを使用して建てられたマルチプレイ用サーバで行われていました。\n            (サーバMODに分類される拡張サーバでは、有志が開発したプラグインを組み合わせることで\n            一定時間透明になったり、ワープしたりと、様々なアクションを起こすことができます)", _vm._h('br'), "\n            あるとき、いつも見ていた生放送の配信者が言いました。", _vm._h('br'), "\n            「自分でもプラグインが作れたら、もっと面白くできるのに。」", _vm._h('br'), "\n            私を含めて、少数の配信者は自分でプラグインを開発して、オリジナルの遊びを行っていましたが、\n            多くの人たちはそうではありませんでした。", _vm._h('br'), "\n            そこで、私は考えました。", _vm._h('br'), " ", _vm._h('br'), "\n            「Webの情報だけだとわからない人がいる。本など、紙媒体のほうが向いている人がいるのではないか。」\n            ", _vm._h('br'), _vm._h('br'), "\n            その考えのもとに、2014年初の同人誌を執筆しました。この本は、超会議内で、声をかけてくれた人に\n            プレゼントするという無償のものでした。", _vm._h('br'), "\n            そして、受け取った方々から良い反響をいただき、作成してよかったと感じました。\n            もちろん、何人かの方々は、これをきっかけにプラグインの開発を始めました。\n            ", _vm._h('br'), _vm._h('br'), "\n            このような経験をして、もっと多くの方々の手にこのようなマインクラフト同人誌が渡れば、\n            マインクラフトを盛り上げれるのではないか、と考えるようになりました。\n            ", _vm._h('br'), _vm._h('br'), "\n            マインクラフトを盛り上げたい。その目標を達成するために、私は同人誌を書いています。\n          "])])
	}]}

/***/ },
/* 55 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;
	  return _vm._h('main', {}, [_vm._h('v-parallax', {
	    attrs: {
	      "src": "/static/back.jpg",
	      "height": 300
	    }
	  }, [_vm._h('v-container', {
	    staticClass: "white-text center-align"
	  }, [_vm._m(0), " ", _vm._h('h2', [_vm._s(_vm.$t('top.circle_name'))]), " ", _vm._h('v-row', [_vm._h('v-grid', {
	    attrs: {
	      "s12": ""
	    }
	  }, [_vm._h('v-btn-link', {
	    staticClass: "waves-effect waves-light",
	    attrs: {
	      "large": true,
	      "href": "#modal"
	    }
	  }, [_vm._s(_vm.$t('top.whats_doujin'))])])])])]), " ", _vm._h('v-container', {
	    staticClass: "promo-outer"
	  }, [_vm._h('v-row', [_vm._h('v-grid', {
	    attrs: {
	      "s12": "",
	      "m6": ""
	    }
	  }, [_vm._m(1)]), " ", _vm._h('v-grid', {
	    attrs: {
	      "s12": "",
	      "m6": ""
	    }
	  }, [_vm._m(2)])])])])
	},staticRenderFns: [function (){var _vm=this;
	  return _vm._h('h3', ["Minecraft", _vm._h('br', {
	    staticClass: "hide-on-med-and-up"
	  }), "同人サークル"])
	},function (){var _vm=this;
	  return _vm._h('div', {
	    staticClass: "promo"
	  }, [_vm._h('img', {
	    attrs: {
	      "src": "/static/svg/webdesign/startup.svg"
	    }
	  }), " ", _vm._h('p', {
	    staticClass: "promo-caption"
	  }, ["プレイ人口増加"]), " ", _vm._h('p', {
	    staticClass: "promo-info"
	  }, ["\n            私たちは、マインクラフトという素晴らしいゲームが大好きです。\n            今日、遊び以外にも学問や研究分野で使用されるなど、幅広く関心を集めています。\n            関心を持つ人たちを、遊びにつなげることができれば、\n            マインクラフトをもっと盛り上げることができます。", _vm._h('br'), "\n            私たちは、マインクラフトを遊ぶ人たちを増やします。\n          "])])
	},function (){var _vm=this;
	  return _vm._h('div', {
	    staticClass: "promo"
	  }, [_vm._h('img', {
	    attrs: {
	      "src": "/static/svg/webdesign/brainstorming.svg"
	    }
	  }), " ", _vm._h('p', {
	    staticClass: "promo-caption"
	  }, ["ファンが集う場所"]), " ", _vm._h('p', {
	    staticClass: "promo-info"
	  }, ["\n            マインクラフトの情報源やコミュニティは、インターネット上に散在しています。\n            もっとマインクラフトを盛り上げるためには、幅広く情報がまとめられている\n            場所が必要です。そして、日本中のマインクラフトファンが楽しめる場所を提供する\n            ことはとても重要です。", _vm._h('br'), "\n            私たちは、良質な情報とコミュニティを提供します。\n          "])])
	}]}

/***/ },
/* 56 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;
	  return _vm._h('header', {
	    staticClass: "z-depth-1"
	  }, [_vm._h('v-nav', {
	    attrs: {
	      "nav-class": "z-depth-0 grey lighten-5"
	    }
	  }, [_vm._h('div', {
	    staticClass: "nav-wrapper container"
	  }, [_vm._h('router-link', {
	    staticClass: "brand-logo left",
	    attrs: {
	      "to": "/"
	    }
	  }, ["Hoge", _vm._m(0)]), " ", _vm._h('ul', {
	    staticClass: "right hide-on-med-and-down nav-link-list"
	  }, [_vm._h('li', [_vm._h('router-link', {
	    attrs: {
	      "to": "/",
	      "exact": ""
	    }
	  }, [_vm._s(_vm.$t('menu.top'))])]), " ", _vm._h('li', [_vm._h('router-link', {
	    attrs: {
	      "to": "/overview"
	    }
	  }, [_vm._s(_vm.$t('menu.overview'))])]), " ", _vm._h('li', [_vm._h('router-link', {
	    attrs: {
	      "to": "/members"
	    }
	  }, [_vm._s(_vm.$t('menu.members'))])]), " ", _vm._h('li', [_vm._h('router-link', {
	    attrs: {
	      "to": "/contact"
	    }
	  }, [_vm._s(_vm.$t('menu.contact'))])]), " "])]), " ", _vm._h('v-container', [_vm._h('div', {
	    staticClass: "nav-wrapper center-align hide-on-large-only sub-menu"
	  }, [_vm._h('ul', {
	    staticClass: "nav-link-list"
	  }, [_vm._h('li', {
	    staticClass: "sub-menu-item"
	  }, [_vm._h('router-link', {
	    attrs: {
	      "to": "/",
	      "exact": ""
	    }
	  }, [_vm._s(_vm.$t('menu.top'))])]), " ", _vm._h('li', {
	    staticClass: "sub-menu-item"
	  }, [_vm._h('router-link', {
	    attrs: {
	      "to": "/overview"
	    }
	  }, [_vm._s(_vm.$t('menu.overview'))])]), " ", _vm._h('li', {
	    staticClass: "sub-menu-item"
	  }, [_vm._h('router-link', {
	    attrs: {
	      "to": "/members"
	    }
	  }, [_vm._s(_vm.$t('menu.members'))])]), " ", _vm._h('li', {
	    staticClass: "sub-menu-item"
	  }, [_vm._h('router-link', {
	    attrs: {
	      "to": "/contact"
	    }
	  }, [_vm._s(_vm.$t('menu.contact'))])])]), " "])])])])
	},staticRenderFns: [function (){var _vm=this;
	  return _vm._h('span', {
	    staticClass: "orange-text darken-4"
	  }, [".class"])
	}]}

/***/ }
]);


// WEBPACK FOOTER //
// static/js/app.1429f4521e2c7512ab09.js